<template>
  <div class="documentsettlement-search">
    <b-row>
      <b-col md="10" sm="12">
        <PageTitle icon="fa fa-search" main="Registro" sub="Conciliação Bancária / Caixa" />
      </b-col>
    </b-row>
    <b-row>
      <div class="stats">
        <Stat title="Não Conciliado" :value="this.total_plot_not_conciliation" color="#d54d50" />
        <Stat title="Conciliado" :value="this.total_plot_conciliation" color="#3bc480" />
        <Stat title="Total" :value="this.total_conciliation" color="#3282cd" />
      </div>
    </b-row>
    <hr />
    <b-row>
      <b-col md="2" sm="12">
        <b-form-group 
          label="Liquidação Início:" 
          label-for="documentsettlement-search-start_date">
          <b-form-input
            id="documentsettlement-search-start_date"
            type="date"
            v-model="start_date"
            @input="[loadDocumentSettlements(),loadDocumentSettlementDirects()]"
            size="sm"
          />
        </b-form-group>
      </b-col>
      <b-col md="2" sm="12">
        <b-form-group 
          label="Liquidação Término:" 
          label-for="documentsettlement-search-end_date">
          <b-form-input
            id="documentsettlement-search-end_date"
            type="date"
            v-model="end_date"
            @input="[loadDocumentSettlements(),loadDocumentSettlementDirects()]"
            size="sm"
          />
        </b-form-group>
      </b-col>
      <b-col md="3" sm="12">
        <b-form-group 
          label="Empresa:" 
          label-for="documentsettlement-search-company_id">
          <b-form-select
            id="documentsettlement-search-company_id"
            @input="[loadEntitySettlements(),loadDocumentSettlements(),loadDocumentSettlementDirects()]"
            size="sm"
            :options="companys"
            v-model="company_id"
          />
        </b-form-group>
      </b-col>
      <b-col md="4" sm="12">
        <b-form-group
          label="Conta Banco/Caixa:"
          label-for="documentsettlement-search-entity_settlement_id"
        >
          <b-form-select
            id="documentsettlement-search-entity_settlement_id"
            @input="[loadDocumentSettlements(),loadDocumentSettlementDirects()]"
            size="sm"
            :options="entitysettlements"
            v-model="entity_settlement_id"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="2" sm="12">
        <b-form-group 
          label="Conciliado:" 
          label-for="documentsettlement-search-conciliation">
          <b-form-select
            id="documentsettlement-search-conciliation"
            @input="[loadDocumentSettlements(),loadDocumentSettlementDirects()]"
            size="sm"
            :options="questionboxyesnoalls"
            v-model="conciliation"
          />
        </b-form-group>
      </b-col>
      <b-col md="2" sm="12">
        <b-form-group 
          label="Operação:" 
          label-for="documentsettlement-search-operation_id">
          <b-form-select
            id="documentsettlement-search-operation_id"
            @input="[loadDocumentSettlements(),loadDocumentSettlementDirects()]"
            size="sm"
            :options="operations"
            v-model="operation_id"
          />
        </b-form-group>
      </b-col>
      <b-col md="3" sm="12">
        <b-form-group
          label="Forma de Pagamento/Recebimento:"
          label-for="documentsettlement-search-settlement_form_id"
        >
          <b-form-select
            id="documentsettlement-search-settlement_form_id"
            size="sm"
            :options="settlementforms"
            v-model="settlement_form_id"
          />
        </b-form-group>
      </b-col>
       <b-col md="3" sm="12">
        <b-button
                size="sm"
                class="mt-4 fa"
                :class="icon"
                @click="[loadDocumentSettlements(),showTable = !showTable]"
                variant="light"
            ></b-button>
       </b-col>    
    </b-row>
    <hr />
      <b-card 
        bg-variant="light" 
        text-variant="dark" >
        <b-tabs  
            card >
             <b-tab 
                title="Lançamento(s)" 
                active>
               <b-row>
                    <b-col md="12" sm="12">
                      <template>
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                          aria-controls="my-table"
                        ></b-pagination>
                        <transition name="slide" type="animation" appear>
                          <b-table
                            id="my-table"
                            class="table-responsive"
                            :per-page="perPage"
                            :current-page="currentPage"
                            v-show="showTable"
                            hover
                            key="slide"
                             head-variant="light"
                            :items="documentsettlements"
                            :fields="fieldsDocumentSettlement"
                          >
                            <template v-slot:cell(actions)="data">
                              <b-button
                                
                                title="Recontabilização"
                                size="sm"
                                variant="light"
                                @click="[setReleaseSplot(data.item),showMsgBoxAccounting()]"
                                class="mr-2 mt-2"
                              >
                                <i class="fa fa-exchange"></i>
                              </b-button>
                              <b-button
                                
                                title="Acesso a Contabilização"
                                size="sm"
                                variant="light"
                                v-b-modal.modalAccounting
                                v-show="data.item.accounting_release_splot"
                                @click="accountingRelease(data.item)"
                                class="mr-2 mt-2"
                              >
                                <i class="fa fa-puzzle-piece"></i>
                              </b-button>
                              <b-button
                                
                                title="Informar Compensação"
                                v-b-modal.modalCompensation
                                size="sm"
                                variant="light"
                                @click="compensationSettlement(data.item)"
                                class="mr-2 mt-2"
                              >
                                <i class="fa fa-pencil"></i>
                              </b-button>
                              <b-button
                                
                                title="Conciliar"
                                size="sm"
                                variant="light"
                                v-if="!data.item.conciliation_date"
                                @click="conciliationSettlement(data.item)"
                                class="mr-2 mt-2"
                              >
                                <i class="fa fa-check"></i>
                              </b-button>
                              <b-button
                                
                                title="Desconciliar"
                                size="sm"
                                variant="light"
                                v-if="data.item.conciliation_date"
                                @click="conciliationSettlement(data.item)"
                                class="mr-2 mt-2"
                              >
                                <i class="fa fa-check"></i>
                              </b-button>
                              <b-button 
                                 
                                title = "Cancelar Liquidação" 
                                size="sm" 
                                variant="light" 
                                @click="[setReleaseSplot(data.item),showMsgBoxCanceled()]" 
                                class="mr-2 mt-2">
                                <i class="fa fa-ban"></i>
                            </b-button>
                            </template>
                          </b-table>
                        </transition>
                      </template>
                    </b-col>
                  </b-row>
              </b-tab>
              <b-tab title="Liquidação Direta">
                 <b-row>
                    <b-col md="12" sm="12">
                      <template>
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows_direct"
                          :per-page="perPage"
                          aria-controls="my-table"
                        ></b-pagination>
                        <transition name="slide" type="animation" appear>
                          <b-table
                            id="my-table"
                            class="table-responsive"
                            :per-page="perPage"
                            :current-page="currentPage"
                            v-show="showTable"
                            hover
                            key="slide"
                             head-variant="light"
                            :items="documentsettlement_directs"
                            :fields="fieldsDocumentSettlementDirect"
                          >
                            <template v-slot:cell(actions)="data">
                              <b-button
                                
                                title="Recontabilização"
                                size="sm"
                                variant="light"
                                @click="[setReleaseSplot(data.item),showMsgBoxAccounting()]"
                                class="mr-2 mt-2"
                              >
                                <i class="fa fa-exchange"></i>
                              </b-button>
                              <b-button
                                
                                title="Acesso a Contabilização"
                                size="sm"
                                variant="light"
                                v-b-modal.modalAccounting
                                v-show="data.item.accounting_release_splot"
                                @click="accountingRelease(data.item)"
                                class="mr-2 mt-2"
                              >
                                <i class="fa fa-puzzle-piece"></i>
                              </b-button>
                              <b-button
                                
                                title="Informar Compensação"
                                v-b-modal.modalCompensation
                                size="sm"
                                variant="light"
                                @click="compensationSettlement(data.item)"
                                class="mr-2 mt-2"
                              >
                                <i class="fa fa-pencil"></i>
                              </b-button>
                              <b-button
                                
                                title="Conciliar"
                                size="sm"
                                variant="light"
                                v-if="!data.item.conciliation_date"
                                @click="conciliationSettlement(data.item)"
                                class="mr-2 mt-2"
                              >
                                <i class="fa fa-check"></i>
                              </b-button>
                              <b-button
                                
                                title="Desconciliar"
                                size="sm"
                                variant="light"
                                v-if="data.item.conciliation_date"
                                @click="conciliationSettlement(data.item)"
                                class="mr-2 mt-2"
                              >
                                <i class="fa fa-check"></i>
                              </b-button>
                            </template>
                          </b-table>
                        </transition>
                      </template>
                    </b-col>
                  </b-row>
              </b-tab>
        </b-tabs>

      </b-card>
   
    <b-modal
      id="modalCompensation"
      ref="modal"
      title="Compensado em"
      title-tag="h6"
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      :body-bg-variant="bodyBgVariant"
      :body-text-variant="bodyTextVariant"
      @ok="savecompensationSettlement"
    >
      <b-row>
        <b-col md="4" sm="12">
          <b-form-group
            label="Data de Compensação:"
            label-for="documentsettlement-compensation_date"
          >
            <b-form-input
              id="documentsettlement-compensation_date"
              type="date"
              v-model="documentsettlement.compensation_date"
              size="sm"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      id="modalAccounting"
      centered
      ref="modal"
      size="xl"
      title-tag="h6"
      title="Contabilização"
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      :body-bg-variant="bodyBgVariant"
      :body-text-variant="bodyTextVariant"
      hide-footer
    >
      <b-form>
        <b-table
          class="table-responsive"
          hover
          striped
          head-variant="dark"
          :items="accountingentrys"
          :fields="fieldsAccounting"
        ></b-table>
      </b-form>
    </b-modal>
  </div>
</template>
    

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import PageTitle from "../template/PageTitle";
import Stat from "../home/Stat";
var moment = require("moment");

export default {
  name: "DocumentSettlementSearch",
  components: { PageTitle, Stat },
  data: function() {
    return {
      mode: "insert",
      modeDocumentSettlement: "insert",
      start_date: null,
      end_date: null,
      entity_settlement_id: null,
      company_id: null,
      operation_id: null,
      conciliation: null,
      settlement_form_id: null,
      total_plot_not_conciliation: 0,
      total_plot_conciliation: 0,
      total_conciliation: 0,
      documentsettlement: {},
      documentsettlements: [],
      documentsettlement_directs: [],
      entitysettlements: [],
      operations: [],
      settlementforms: [],
      companys: [],
      accountingentrys: [],
      headerBgVariant: "dark",
      headerTextVariant: "light",
      bodyBgVariant: "light",
      bodyTextVariant: "dark",
      footerBgVariant: "warning",
      footerTextVariant: "dark",
      showTable: false,
      perPage: 5,
      currentPage: 1,
      fieldsDocumentSettlement: [
        { key: "name_operation", label: "Tipo.", sortable: false },
        {
          key: "settlement_date",
          label: "Data Liquidação",
          sortable: false,
          variant: 'secondary',
          formatter: value =>
            value ? moment.utc(value).format("DD-MM-YYYY") : ""
        },
        { key: "name_entity", label: "Nome", sortable: true },
        { key: "name_reduced", label: "Doc.", sortable: false },
        { key: "release_number", label: "Nº.", sortable: false },
        { key: "settlement_value", label: "Valor", sortable: false },
        {
          key: "name_settlement_form",
          label: "Forma de Liquidação",
          sortable: false
        },
        {
          key: "due_date",
          label: "Data Vencto",
          sortable: false,
          formatter: value =>
            value ? moment.utc(value).format("DD-MM-YYYY") : ""
        },
        {
          key: "conciliation_date",
          label: "Data Conciliação",
          sortable: false,
          variant: 'secondary',
          formatter: value =>
            value ? moment.utc(value).format("DD-MM-YYYY") : ""
        },
        {
          key: "compensation_date",
          label: "Data Compensação",
          sortable: false,
          variant: 'secondary',
          formatter: value =>
            value ? moment.utc(value).format("DD-MM-YYYY") : ""
        },
        { key: "actions", label: "Ações" , variant: 'light'}
      ],
      fieldsDocumentSettlementDirect:[
        { key: "name_operation", label: "Tipo.", sortable: false },
        {
          key: "settlement_date",
          label: "Data Liquidação",
          sortable: false,
          variant: 'secondary',
          formatter: value =>
            value ? moment.utc(value).format("DD-MM-YYYY") : ""
        }, 
         {
          key: "direct_release_date",
          label: "Data Lançamento",
          sortable: false,
          formatter: value =>
            value ? moment.utc(value).format("DD-MM-YYYY") : ""
        }, 
        { key: "direct_number", label: "Nº.", sortable: false },
        { key: "comments", label: "Observação", sortable: false },
        { key: "settlement_value", label: "Valor", sortable: false },
        {
          key: "conciliation_date",
          label: "Data Conciliação",
          sortable: false,
          variant: 'secondary',
          formatter: value =>
            value ? moment.utc(value).format("DD-MM-YYYY") : ""
        },
        {
          key: "compensation_date",
          label: "Data Compensação",
          sortable: false,
          variant: 'secondary',
          formatter: value =>
            value ? moment.utc(value).format("DD-MM-YYYY") : ""
        },
        { key: "actions", label: "Ações" , variant: 'light'}
      ],
      fieldsAccounting: [
        {
          key: "accounting_date",
          label: "Contabilizado",
          sortable: false,
          formatter: value =>
            value ? moment.utc(value).format("DD-MM-YYYY") : ""
        },
        { key: 'name_cost_center', label: 'Centro de Custo/Receita', sortable: false },
        { key: "account_plan", label: "Conta", sortable: false },
        { key: "account_name_plan", label: "Descrição", sortable: false },
        { key: "account_against", label: "CP-Conta", sortable: false },
        { key: "account_name_against", label: "CP-Descrição", sortable: false },
        { key: "accounting_value", label: "Valor", sortable: false,variant: 'secondary' },
        { key: 'accounting_nature_account', label: 'Nat.', sortable: false ,variant: 'secondary'},
        { key: "accounting_comments", label: "Historico", sortable: false }
      ],
       questionboxyesnoalls: [
                {value:0,text:'Não'},
                {value:1,text:'Sim'},
                {value:2,text:'Ambos'},
                ],
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    compan() {
      return this.$store.state.compan;
    },
    icon() {
      return this.showTable ? "fa-retweet" : "fa-search";
    },
    rows() {
      return this.documentsettlements.length;
    },
    rows_direct() {
      return this.documentsettlement_directs.length;
    }
  },
  methods: {
     showMsgBoxAccounting() {
        this.boxAccount = ''
        this.$bvModal.msgBoxConfirm('Deseja Recontabilizar o Registro ?',{
            title: 'Por Favor Confirme',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            okTitle: 'SIM',
            cancelTitle: 'NÃO',
            footerClass: 'p-1',
            hideHeaderClose: false,
            centered: true
        })
        .then(async value => {
            this.boxAccount = value
            if(this.boxAccount === true){
                await this.reaccountingRelease()
            }
        })

    },
    showMsgBoxCanceled() {
        this.boxCanceled= ''
        this.$bvModal.msgBoxConfirm('Deseja Cancelar a Liquidação ?',{
            title: 'Por Favor Confirme',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            okTitle: 'SIM',
            cancelTitle: 'NÃO',
            footerClass: 'p-1',
            hideHeaderClose: false,
            centered: true
        })
        .then(async value => {
            this.boxCanceled = value
            if(this.boxCanceled === true){
                await this.cancelSettlement()
            }
        })

    },
    formatDate(date) {
      return moment.utc(date).format("YYYY-MM-DD");
    },
    formatDateTime(date) {
                return moment.parseZone(date).format('YYYY-MM-DD LT')
    },
    async cancelSettlement() {

            this.documentsettlement = {
                id: this.releasesplot.id,
                settlement_date: this.releasesplot.settlement_date,
                company_id: this.releasesplot.company_id,
                release_plot_id: this.releasesplot.release_plot_id,
                entity_settlement_id: this.releasesplot.entity_settlement_id,
                settlement_value: this.releasesplot.settlement_value,
                canceled: true,
                user_canceled_id: this.user.id,
                canceled_date: this.formatDateTime(moment.utc().local())
            }

            const method = "put"
            const id = `/${this.documentsettlement.id}`
            await axios[method](`${baseApiUrl}/documentsettlements${id}`, this.documentsettlement)
                .then(async () => {
                    this.$toasted.global.defaultSuccess();
                    await this.loadDocumentSettlements()
                })
                .catch(showError)
    }, 
    async loadDocumentSettlements() {
      const url = `${baseApiUrl}/documentsettlementsconciliationsearchdatestatus/${this.company_id}/?start_date=${this.start_date}&end_date=${this.end_date}&entity_settlement_id=${this.entity_settlement_id}&operation_id=${this.operation_id}&settlement_form_id=${this.settlement_form_id}&conciliation=${this.conciliation}`;
      await axios.get(url).then(async res => {
        this.documentsettlements = res.data;
        await this.loadDocumentSettlementsConciliationValue();
        await this.loadDocumentSettlementsNotConciliationValue();
        await this.loadDocumentSettlementsConciliationTotal();
      });

    },
    async loadDocumentSettlementDirects() {
      const url = `${baseApiUrl}/documentsettlementsdirectsearchdatestatus/${this.company_id}/?start_date=${this.start_date}&end_date=${this.end_date}&entity_settlement_id=${this.entity_settlement_id}&operation_id=${this.operation_id}&settlement_form_id=${this.settlement_form_id}&conciliation=${this.conciliation}`;
      await axios.get(url).then(res => {
        this.documentsettlement_directs = res.data;
      });

    },
    async loadDocumentSettlementsConciliationValue() {
      this.total_plot_conciliation = 0;

      const url = `${baseApiUrl}/documentsettlementsconciliationvalue/${this.company_id}/?start_date=${this.start_date}&end_date=${this.end_date}&entity_settlement_id=${this.entity_settlement_id}&operation_id=${this.operation_id}&settlement_form_id=${this.settlement_form_id}&conciliation=${this.conciliation}`;
      await axios.get(url).then(res => {
        this.total_plot_conciliation = res.data[0].total_plot_conciliation;
      });
    },
    async loadDocumentSettlementsNotConciliationValue() {
      this.total_plot_not_conciliation = 0;

      const url = `${baseApiUrl}/documentsettlementsnotconciliationvalue/${this.company_id}/?start_date=${this.start_date}&end_date=${this.end_date}&entity_settlement_id=${this.entity_settlement_id}&operation_id=${this.operation_id}&settlement_form_id=${this.settlement_form_id}&conciliation=${this.conciliation}`;
      await axios.get(url).then(res => {
        this.total_plot_not_conciliation =
          res.data[0].total_plot_not_conciliation;
      });
    },
    async loadDocumentSettlementsConciliationTotal() {
      this.total_conciliation = 0;

      const url = `${baseApiUrl}/documentsettlementsconciliationtotal/${this.company_id}/?start_date=${this.start_date}&end_date=${this.end_date}&entity_settlement_id=${this.entity_settlement_id}&operation_id=${this.operation_id}&settlement_form_id=${this.settlement_form_id}&conciliation=${this.conciliation}`;
      await axios.get(url).then(res => {
        this.total_conciliation = res.data[0].total_conciliation;
      });
    },
    async loadOperation() {
      const url = `${baseApiUrl}/operations`;
      await axios.get(url).then(res => {
        this.operations = res.data.map(operation => {
          return { value: operation.id, text: operation.name_operation };
        });
      });
    },
    async loadCompanys() {
      const url = `${baseApiUrl}/companys`;
      await axios.get(url).then(res => {
        this.companys = res.data.map(company => {
          return { value: company.id, text: company.name_company };
        });
      });
    },
    async loadEntitySettlements() {
      const url = `${baseApiUrl}/entitysettement/${this.company_id}`;
      await axios.get(url).then(res => {
        this.entitysettlements = res.data.map(entitysettlement => {
          return {
            value: entitysettlement.id,
            text: `${entitysettlement.name_entity} - ${entitysettlement.cnpj_cpf}`
          };
        });
      });
    },
    async loadSettlementForms() {
      const url = `${baseApiUrl}/settlementforms`;
      await axios.get(url).then(res => {
        this.settlementforms = res.data.map(settlementform => {
          return {
            value: settlementform.id,
            text: settlementform.name_settlement_form
          };
        });
      });
    },
   async conciliationSettlement(documentsettlement) {

      if(this.formatDate(this.compan.accounting_period_start) > this.formatDate(moment.utc().local())){
        this.$toasted.global.defaultError({msg:'Data esta fora do período contábil'})
        }else if(this.formatDate(this.compan.accounting_period_end) < this.formatDate(moment.utc().local())){
        this.$toasted.global.defaultError({msg:'Data esta fora do período contábil'})
        }else{

      this.documentsettlement.id = documentsettlement.id;

            if (this.documentsettlement.id > 0) {
              this.documentsettlement.id = documentsettlement.id;
              this.documentsettlement.settlement_date = this.formatDate(
                documentsettlement.settlement_date
              );
              this.documentsettlement.entity_settlement_id =documentsettlement.entity_settlement_id;
              this.documentsettlement.conciliation_date = documentsettlement.conciliation_date ? null : this.formatDate(moment.utc().local());
              this.documentsettlement.compensation_date = documentsettlement.compensation_date ? null : this.formatDate(moment.utc().local());
            }
                  const method = "put";
                  const id = `/${this.documentsettlement.id}`;
                  await axios[method](
                      `${baseApiUrl}/documentsettlements${id}`,
                      this.documentsettlement
                    )
                      .then(async () => {
                        this.$toasted.global.defaultSuccess();
                        await this.loadDocumentSettlements();
                        await this.loadDocumentSettlementDirects();
                        this.documentsettlement = {};
                      })
                      .catch(showError);
        }          
    },
    compensationSettlement(documentsettlement) {
      this.documentsettlement.id = documentsettlement.id;
      this.documentsettlement.settlement_date = this.formatDate(
        documentsettlement.settlement_date
      );
      this.documentsettlement.entity_settlement_id =
        documentsettlement.entity_settlement_id;
    },
   async savecompensationSettlement() {
      if (this.documentsettlement.id > 0) {
        const method = "put";
        const id = `/${this.documentsettlement.id}`;
        await axios[method](
          `${baseApiUrl}/documentsettlements${id}`,
          this.documentsettlement
        )
          .then(async () => {
            this.$toasted.global.defaultSuccess();
            await this.loadDocumentSettlements();
            this.documentsettlement = {};
          })
          .catch(showError);
      }
    },
    async printerDocumentSettlement() {
      if (!this.start_date || !this.end_date) {
        this.$toasted.global.defaultError({ msg: "Data não informada" });
      } else if (!this.company_id) {
        this.$toasted.global.defaultError({ msg: "Empresa não informada" });
      } else if (!this.operation_id) {
        this.$toasted.global.defaultError({ msg: "Operação não informada" });
      } else if (!this.document_status_id) {
        this.$toasted.global.defaultError({ msg: "Status não informada" });
      } else {
        const url = `${baseApiUrl}/documentsettlementssearchdatestatusprinter/${this.company_id}/?start_date=${this.start_date}&end_date=${this.end_date}&status_id=${this.document_status_id}&operation_id=${this.operation_id}`;
       await axios.get(url);
        window.open(url);
      }
    },
   async reaccountingRelease() {
      if(this.compan.require_account_entry === 1){
          await axios["post"](`${baseApiUrl}/accountingreleasesplot`, this.releasesplot)
            .then(async () => {
              this.$toasted.global.defaultSuccess();
              await this.loadDocumentSettlements();
            })
            .catch(showError)
      }
    },
    setReleaseSplot(releasesplot){
        this.releasesplot = { ...releasesplot }
    },
    async accountingRelease(releasesplot) {
      const id = releasesplot.release_plot_id;
      await axios
        .get(`${baseApiUrl}/accountingentrysreleasesplots/${id}`)
        .then(res => {
          this.accountingentrys = res.data;
        });
    }
  },
 async mounted() {
   await this.loadSettlementForms();
   await this.loadOperation();
   await this.loadCompanys();

      this.start_date = moment().startOf('month').format('YYYY-MM-DD') 
      this.end_date = moment().endOf('month').format('YYYY-MM-DD') 
      
      if (this.compan) {
        this.company_id = this.compan.id;
      }
      this.showTable = true;
  }
};
</script>

<style>
.stats {
  flex: 1;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 0px 65px 0px 65px;
  border-radius: 60px;
}

.stats {
  font-size: 0.7rem;
}

.documentsettlement-search {
  font-size: 0.7rem;
}

.documentsettlement-search input,
label,
form {
  font-size: 0.7rem;
}
.documentsettlement-search button {
  font-size: 0.7rem;
}

.documentsettlement-search select {
  font-size: 0.7rem;
}

.documentsettlement-search table {
  font-size: 0.7rem;
}

#modalCompensation {
  font-size: 0.7rem;
}

#modalCompensation button {
  font-size: 0.7rem;
}

#modalCompensation input,
label,
form {
  font-size: 0.7rem;
}

@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
</style>
